// The top bar's "More" menu — which navigation entries fit on the bar and
// which fold into More (TopNav.jsx measures, this decides).
//
// Pure: no React, no DOM. The bar hands in each entry's natural width (in
// order), the room it has, the More trigger's width and the gap between
// triggers; out comes how many entries stay on the bar. The rest go into
// More, in the same order, so the bar reads left to right as it always did
// and the last items are the first to fold.

// widths: natural widths of the entries, in bar order.
// available: the room the menubar has (px).
// moreWidth: the More trigger's width (px). gap: space between triggers.
export function visibleNavCount(widths, available, moreWidth, gap = 0) {
  const n = widths.length;
  const run = (k) => {
    let sum = 0;
    for (let i = 0; i < k; i += 1) sum += widths[i];
    return sum + Math.max(0, k - 1) * gap;
  };
  if (run(n) <= available) return n;
  let k = n - 1;
  while (k > 0 && run(k) + gap + moreWidth > available) k -= 1;
  return k;
}

// The entries that fold into More, as rows the dropdown's menu tree draws:
// a menu becomes a row with a fly-out of its own items, a link a row that
// opens its address. `tabLabel` is what a link names the tab it opens.
export function entriesAsMenuRows(entries) {
  return (entries || []).map((entry) => (entry.kind === 'menu'
    ? { ...entry.item, id: entry.id, label: entry.label, url: null, children: entry.items || [], iconFallback: entry.iconFallback, emptyText: entry.emptyText }
    : { ...entry.item, id: entry.id, label: entry.label, tabLabel: entry.tabLabel || entry.label, url: entry.url, children: [], iconFallback: entry.iconFallback }));
}
